const initState={
   pages:[],
   
 }
 
  const ComparisonReducer=(state=initState,action)=>{
     return state;
 }
 
 export default ComparisonReducer